/* ========================================================================
   © 2026 SpeedToLead Framework. All rights reserved.
   ======================================================================== */
export const HOME = {
    emergentLink: "home-emergent-link",
    heroOverline: "hero-overline",
    heroHeadline: "hero-headline",
    heroCta: "hero-cta",
    heroUrlInput: "hero-url-input",
};

export const WIZARD = {
    panel: "wizard-panel",
    progress: "wizard-progress",
    inputUrl: "wizard-input-url",
    inputPhone: "wizard-input-phone",
    inputOwner: "wizard-input-owner",
    inputEmail: "wizard-input-email",
    inputNeighborhoods: "wizard-input-neighborhoods",
    inputFaq1: "wizard-input-faq-1",
    inputFaq2: "wizard-input-faq-2",
    inputFaq3: "wizard-input-faq-3",
    btnNext: "wizard-btn-next",
    btnPrev: "wizard-btn-prev",
    btnRunTest: "wizard-btn-run-test",
    btnStartCheckout: "wizard-btn-start-checkout",
    results: "wizard-results",
    statusLive: "wizard-status-live",
};

export const CHECKOUT = {
    page: "checkout-success-page",
    status: "checkout-status",
    goWorkspace: "checkout-go-workspace",
};

export const WORKSPACE = {
    page: "workspace-page",
    webhookUrl: "workspace-webhook-url",
    webhookCopy: "workspace-webhook-copy",
    snippetTabs: "workspace-snippet-tabs",
    snippetWp: "workspace-snippet-wordpress",
    snippetWebflow: "workspace-snippet-webflow",
    snippetShopify: "workspace-snippet-shopify",
    snippetCopy: "workspace-snippet-copy",
    adInputCity: "workspace-ad-city",
    adInputNiche: "workspace-ad-niche",
    adGenerate: "workspace-ad-generate",
    adResult: "workspace-ad-result",
    adDeploy: "workspace-ad-deploy",
};
